module.exports = __webpack_public_path__ + "static/img/right-num-row-4.34ad3439.webp";